'use client';

import React from 'react';

interface TopBarIndicatorProps {
  isVisible: boolean;
  className?: string;
}

export const TopBarIndicator: React.FC<TopBarIndicatorProps> = ({ isVisible, className = '' }) => {
  if (!isVisible) return null;

  return (
    <>
      <div className={`fixed left-0 top-0 z-[9999] h-2 w-full overflow-hidden ${className}`}>
        <div
          className='h-full animate-[loading_2s_ease-in-out_infinite]'
          style={{
            background: `linear-gradient(90deg, transparent 0%, #EF9519 50%, transparent 100%)`
          }}
        />
      </div>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <style jsx>{`
        @keyframes loading {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </>
  );
};
